import { CirclekDiscontinuationPage, ScrollToTop, isCirclekDomain, setOriginationStorage } from '@applyonline/shared'
import { ReactNode, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom'
import { AppContext, useAppStoreProvider } from '../../data/AppContext'
import { B2C_MERCHANT_IDS } from '../../types/constants'
import { useMerchantIdFromSubdomain } from '../ApplicationForm/hooks'
import VouchedPage from '../Vouched/VouchedPage'
import TopLevelRoutes from './Routes'
import Footer from './components/Footer'
import Header from './components/Header'

const App = (): ReactNode => {
  const { i18n } = useTranslation()

  const appStore = useAppStoreProvider()

  useEffect(() => {
    setOriginationStorage(appStore.originationFromUrl)
  }, [appStore.originationFromUrl])

  const merchantId = useMerchantIdFromSubdomain()
  const showCirclekDiscontinuation = isCirclekDomain() || merchantId === B2C_MERCHANT_IDS.circlek

  return (
    <AppContext.Provider value={appStore}>
      <Router>
        <ScrollToTop />
        {showCirclekDiscontinuation ? (
          <>
            <Header language={i18n.language} />
            <CirclekDiscontinuationPage />
            <Footer />
          </>
        ) : (
          <Routes>
            <Route path="/creditapplication/:id/vouchedPage" element={<VouchedPage />} />
            <Route
              path="/*"
              element={
                <>
                  <Header language={i18n.language} />
                  <TopLevelRoutes />
                  <Footer />
                </>
              }
            />
          </Routes>
        )}
      </Router>
    </AppContext.Provider>
  )
}
export default App
